module.exports = __webpack_public_path__ + "img/MixedServices.9bb0a7bb.svg";